import { render, staticRenderFns } from "./ChatRes.vue?vue&type=template&id=7eaceb3c&scoped=true"
import script from "./ChatRes.vue?vue&type=script&lang=js"
export * from "./ChatRes.vue?vue&type=script&lang=js"
import style0 from "./ChatRes.vue?vue&type=style&index=0&id=7eaceb3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eaceb3c",
  null
  
)

export default component.exports